import { Size } from '@optimus-web/common';
import {
    RadioBackgroundElement,
    RadioElement,
    RadioInnerCircleElement,
    RadioInputElement,
    RadioOuterCircleElement,
} from './style';

export interface RadioProps {
    className?: string;
    checked?: boolean;
    disabled?: boolean;
    children?: React.ReactNode;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    onFocus?: React.FocusEventHandler<HTMLInputElement>;
    onBlur?: React.FocusEventHandler<HTMLInputElement>;
    inputHidden?: boolean;
    value?: string;
    size?: Exclude<Size, 'extraLarge'>;
}

export const Radio = ({
    className,
    checked,
    disabled,
    inputHidden,
    children,
    onChange,
    onFocus,
    onBlur,
    size = 'medium',
    ...other
}: RadioProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled && onChange) {
            onChange(e, !checked);
        }
    };

    return (
        <RadioElement className={className} $disabled={disabled} inputHidden={inputHidden} size={size}>
            <RadioInputElement
                {...other}
                type="radio"
                checked={checked}
                disabled={disabled}
                onChange={handleChange}
                onFocus={onFocus}
                onBlur={onBlur}
                aria-checked={checked}
            />
            <RadioBackgroundElement aria-hidden>
                <RadioOuterCircleElement checked={checked} disabled={disabled} />
                <RadioInnerCircleElement checked={checked} disabled={disabled} />
            </RadioBackgroundElement>
        </RadioElement>
    );
};
